var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.6234 3.00395L14.2249 3C11.5302 3 9.78878 4.8353 9.78878 7.67593V9.83184H7.37715C7.16875 9.83184 7 10.0054 7 10.2195V13.3431C7 13.5572 7.16895 13.7306 7.37715 13.7306H9.78878V21.6126C9.78878 21.8267 9.95753 22 10.1659 22H13.3124C13.5208 22 13.6896 21.8265 13.6896 21.6126V13.7306H16.5093C16.7177 13.7306 16.8865 13.5572 16.8865 13.3431L16.8876 10.2195C16.8876 10.1167 16.8478 10.0182 16.7772 9.9455C16.7066 9.87276 16.6103 9.83184 16.5103 9.83184H13.6896V8.00424C13.6896 7.12583 13.8933 6.6799 15.0073 6.6799L16.623 6.67931C16.8312 6.67931 17 6.50576 17 6.29189V3.39137C17 3.1777 16.8314 3.00435 16.6234 3.00395Z","fill":"#262F56"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
